import { cx } from '@emotion/css';
import { FC, useEffect, useState } from 'react';

export const Heading: FC<{
  mediaUrl?: string;
  title?: string;
  gradientPlaceholder: string;
}> = ({ mediaUrl, title, gradientPlaceholder }) => {
  const isVideo = mediaUrl ? mediaUrl.endsWith('.mp4') : false;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!mediaUrl) {
      setIsLoading(false);
    }
  }, [mediaUrl]);

  return (
    <div
      className={cx(
        'w-full h-28 sm:h-32 md:h-36 flex items-center justify-center rounded-lg overflow-hidden',
        {
          'animate-pulse bg-gray-100': isLoading,
          'bg-black': !isLoading,
        }
      )}
    >
      {mediaUrl && isVideo && (
        <video
          className="w-full h-full object-cover"
          src={mediaUrl}
          loop
          autoPlay
          muted
          onLoadedData={() => setIsLoading(false)}
        >
          Your browser does not support the video tag.
        </video>
      )}

      {mediaUrl && !isVideo && (
        <img
          src={mediaUrl}
          onLoad={() => setIsLoading(false)}
          className="w-full h-full object-cover"
        />
      )}

      {!mediaUrl && (
        <div
          className="w-full h-full flex items-center justify-center"
          style={{ background: gradientPlaceholder }}
        >
          <span className="text-4xl font-bold text-white">
            {title?.charAt(0).toUpperCase()}
          </span>
        </div>
      )}
    </div>
  );
};
